import type { OrigemDocumentoEncerramento } from '../types/encerramento.types';

const ROTA_PROCESSO: Record<OrigemDocumentoEncerramento, (processoId: string) => string> = {
  secretaria: (processoId) => `/admin-geral/secretaria/processos/${processoId}`,
  parte: (processoId) => `/arbitral/${processoId}`,
  arbitro: (processoId) => `/arbitro/processos/${processoId}`,
  advogado: (processoId) => `/advogado/processos/${processoId}`,
  notificado: (processoId) => `/portal/arbitragem/${processoId}`,
};

export function rotaProcessoPorOrigem(
  origem: OrigemDocumentoEncerramento,
  processoId: string,
): string {
  return ROTA_PROCESSO[origem](processoId);
}
